export default __webpack_public_path__ + "static/media/fridge2-afterA-480w.01e57ae2.png";